<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="card" v-if="hasPermission($store.state.user, 'EXPORT_READ')">
        <div class="card-header">
          <i class="icon-rocket"></i>
          Export
        </div>
        <div class="card-block">
          <Tabs v-model="activeTab" @input="changeTab">
            <Tab
              :key="`tab-${index}`"
              v-for="(item, index) of authorizedTabs"
              :header="item.label"
            >
            </Tab>
          </Tabs>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Clients",
          name: "export-clients",
          requiredPermission: "EXPORT_CLIENT_READ",
        },
        {
          label: "Prospects",
          name: "export-prospects",
          requiredPermission: "EXPORT_PROSPECT_READ",
        },
        {
          label: "Commandes",
          name: "export-orders",
          requiredPermission: "EXPORT_ORDER_READ",
        },
        {
          label: "Prestataires",
          name: "export-prestataires",
          requiredPermission: "EXPORT_COACH_READ",
        },
        {
          label: "Leads & Marketing",
          name: "marketing-form",
          requiredPermission: "EXPORT_MARKETING_FORM_READ",
        },
        {
          label: "NOVA",
          name: "export-nova",
          requiredPermission: "EXPORT_NOVA_READ",
        },
        {
          label: "Suivi marge comptable",
          name: "accounting-margin-rate",
          requiredPermission: "EXPORT_BALANCE_COMPTABLE_READ",
        },
        {
          label: "Balance comptable",
          name: "export-solde-comptable",
          requiredPermission: "EXPORT_BALANCE_COMPTABLE_READ",
        },
        {
          label: "Compta",
          name: "export-compta",
          requiredPermission: "EXPORT_COMPTA_READ",
        },
      ],
    };
  },

  computed: {
    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return this.hasPermission(
          this.$store.state.user,
          tab.requiredPermission,
        );
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      if (index >= 0) {
        this.$router.push({ name: this.authorizedTabs[index].name });
      }
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) => tab.name === currentPath,
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>
